import { render, staticRenderFns } from "./AnswerList.vue?vue&type=template&id=c7de9644&scoped=true&"
import script from "./AnswerList.vue?vue&type=script&lang=js&"
export * from "./AnswerList.vue?vue&type=script&lang=js&"
import style0 from "./AnswerList.vue?vue&type=style&index=0&id=c7de9644&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7de9644",
  null
  
)

export default component.exports